<template>
  <div>
    <div class="container p-0">
      <ParkTrailsFilter/>
      <hr class="mb-4 mt-1">
    </div>
    <div class="container">
      <h2 class="mb-4 display-5">
        <i v-if="hasFilter" class="text-muted"> {{ $t('park_trails.filter_applied') }}</i>
      </h2>

      <div v-for="(trail, index) in trails" :key="trail.id">
        <a :href="`/trails/${trail.countrySlug}/${trail.regionSlug}/${trail.slug}`">
          <div class="row big-list">
            <div class="col-sm-1 d-none d-md-block p-0 position-relative">
              <span class="rubik-mono"><strong>{{index+1}}</strong></span>
            </div>
            <div class="col-4 col-sm-2">
              <div class="square"  style="max-width: 200px">
                <img class="img-fluid rounded-lg" :src="trail.staticMapImage" alt="" width="239" height="120">
              </div>
            </div>
            <div class="col-8 col-sm-9 my-2 d-flex align-items-center">
              <div>
                <p class="p-0 my-1">
                  <span class="badge mr-2" :class="trail.difficulty.toLowerCase()">
                    {{ trail.difficulty }}
                  </span>
                </p>
                <p class="display-5 m-0"><strong>{{ trail.name }}</strong></p>

                <p>
                  <span class="d-block d-md-inline text-muted" rel="noopener">
                    {{ trail.shortAddress }}
                  </span>
                  <span class="mx-1 d-none d-md-inline">&middot;</span>
                  {{ trail.averageRating }}
                  <small><span class="material-icons">star</span></small>
                  <span class="mx-1">&middot;</span>
                  <span>{{ $t('park_trails.number_of_ratings_reviews', { number_of_ratings: trail.numberOfRatings }) }}</span>
                  <span class="py-1">
                  </span>
                </p>
              </div>
            </div>
          </div>
        </a>
        <hr class="my-4">
      </div>
      <div class="row mb-4">
        <div class="col-12 col-md-4 mx-auto">
          <button class="btn btn-block btn-primary my-4" @click="moreClicked">{{ $t('shared.load_more') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import ParkTrailsFilter from './components/ParkTrailsFilter.vue';

export default defineComponent({
  components: {
    ParkTrailsFilter,
  },
  computed: {
    trails() {
      if (this.graphResponse == null) {
        return [];
      }
      // eslint-disable-next-line max-len
      const trailCount = this.graphResponse.parkTrails.length > this.$store.getters['parkTrails/countToShow'] ? this.$store.getters['parkTrails/countToShow'] : this.graphResponse.parkTrails.length;
      return this.graphResponse.parkTrails.slice(0, trailCount);
    },
    graphResponse() {
      return this.$store.state.parkTrails.graphResponse;
    },
    parkName() {
      return window.parkName;
    },
    hasFilter() {
      return this.$store.getters['parkTrails/hasFilter'];
    },
  },
  beforeCreate() {
    this.$store.dispatch('parkTrails/initialiseStore');
  },
  methods: {
    moreClicked() {
      this.$store.commit('parkTrails/incrementPageCount');
    },
  },
});
</script>
